import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ShelfProduct from "components/ShelfProduct";
import ShelfPaginator from "components/ShelfPaginator";
import Error500 from "components/Error500";
import { withRouter } from 'react-router';
import PlpEmpty from "components/Shelf/PlpEmpty";
import queryString from 'query-string';
import style from './style.scss';//NOSONAR



let _isMounted = false;
let isCompletedLoaded = true;
let maxProducts = 40;
let page = 0;

const ShelfFrequentProducts = (props) => {

    const params = props.location && queryString.parse(props.location.search);
    let numPage = !props.withOutUrl && params && params.page ? params.page : 1;

    if(props.currentPage && props.currentPage > 0){
        numPage = props.currentPage;
    }
    const callbackAddToCart = props.callbackAddToCart;
    const callbackPaginator = props.callbackPaginator;
    const totalProducts = props.totalProducts;

    const [currentPage, setCurrentPage] = useState(Number(numPage) ? Number(numPage) : 1);
    const [productsQty, setProductQty] = useState([]);
    const products = props.products;
    const list = props.list

    useEffect(() => {
        _isMounted = true;
        page = props.currentPage ? props.currentPage : currentPage;
    
        loadMore(page);
        


    }, [props.products]);


    const loadMore = (_page) => {
        
        if (_isMounted) {
            isCompletedLoaded = true;
            let itemQty = !props.withOutUrl ? paginate(products, maxProducts, _page) : products;
            setProductQty(itemQty)
            setCurrentPage(_page);
        }
    }

    const paginate = (data, pageSize, pageNumber) => {
        props.history.push('?page=' + pageNumber)
        return data.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
    }

    const setPage = (paramPage) => {
        page = paramPage;
        if(callbackPaginator){
            callbackPaginator(paramPage);

            return null
        }
        loadMore(page);
        
    }


    const totalPages = totalProducts > 0 ? Math.ceil(totalProducts / maxProducts) : ((products.length > 0)  ? Math.ceil(products.length / maxProducts) : 0);


    return (
        <div className="shelf-frequent-wrapper">
            <div className="shelf-frequent-wrap">
                {products.length > 0 && <div className="shelf-frequent-content">
                    <ul className="shelf-frequent-list">
                        {productsQty.map((product, i) => {
                            const item = product.items[0] || product.item;
                            const gtmData = {
                                'name': product.productName,
                                'id': item.itemId,
                                'refId': item.referenceId[0].Value,
                                'price': item.prices.regular,
                                'brand': product.brand,
                                'category': product.categories[0] || '',
                                'variant': '',
                                'list': list,
                                'position': (product.pos || product.pos === 0) ? product.pos : i,
                                'type': 'impression-plp'
                            };

                            return (<li className="shelf-frequent-item" key={product.productId}>
                                <ShelfProduct product={product} position={i} listTitle={list} gtmData={gtmData} callbackAddToCart={callbackAddToCart}/>
                            </li>)
                        })}
                    </ul>
                </div>}

                {(isCompletedLoaded && (products.length === 0)) && <PlpEmpty/>}
                {!isCompletedLoaded && products.length === 0 && <Error500/>}
                {!isCompletedLoaded && products.length > 0 && <div className='shelf-frequent-not-loaded'>
                    No se cargaron todos los productos solicitados. <button className='shelf-frequent-not-loaded-btn'>Intenta nuevamente</button>
                </div>}
                {((products.length > 0 && products.length > maxProducts) || (callbackPaginator && totalProducts > maxProducts)) && <ShelfPaginator pages={totalPages} setPage={setPage} currentPage={Number(page)}/>}
            </div>
        </div>
    )

};

ShelfFrequentProducts.propTypes = {
    title: PropTypes.string,
    history: PropTypes.object,
    location: PropTypes.object,
    products: PropTypes.array,
};

export default withRouter(ShelfFrequentProducts);
